import { ColumnMetadata } from "~/components/DataGrid";
import { AssetColumns, Token } from "~/modules/assets/types";
import { Networks } from "~/schema";
import { BlockchainExplorerLink } from "~/components/BlockchainExplorerLink";
import { Badge, BadgeVariants } from "~/components/Badge";
import { AssetTableRowData } from "../types";
import { CatalogReferenceDataSlugs } from "~/modules/catalog/types";

// // // //

export const CONTRACT_ADDRESS_COLUMN: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "token_address",
    label: "Contract Address",
    tooltip: CatalogReferenceDataSlugs.address,
    type: "string",
    width: 180,
    loginRequired: true,
    render: (item, { size }) => {
        if (item.isAsset) {
            if (item.tokens.length === 1) {
                return (
                    <BlockchainExplorerLink
                        address={item.tokens[0].address}
                        networkSlug={item.tokens[0].network.slug}
                        analyticsLabel="Data Grid - Contract Address Link"
                        size={size}
                        type="token"
                    />
                );
            }

            return (
                <Badge
                    size={size}
                    rounded="md"
                    label={`${item.tokens.length} Addresses`}
                    variant={BadgeVariants.gray}
                />
            );
        }

        const token = item as Token;
        const network = token.network.slug as Networks;
        return (
            <BlockchainExplorerLink
                address={token.address}
                networkSlug={network}
                analyticsLabel="Data Grid - Contract Address Link"
                size={size}
                type="token"
            />
        );
    },
};
